<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('position')"
      :columns="columns"
      :column_search="false"
      resource_url="/staff/position/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <position-modal ref="position_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  format_date,
  format_currency,
} from "@/utils";
import PositionModal from "./position_modal/Index.vue";

export default {
  name: "PositionDatatable",
  components: { GenericTable, PositionModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: this.$t("name"),
          name: "name",
          data: (row) => row.name || "-",
        },
        {
          title: this.$t("description"),
          name: "description",
          data: (row) => row.description || "-",
        },
        {
          title: this.$t("salary range"),
          name: "salary_range",
          data: (row) => {
            if (
              row.settings &&
              row.settings.min_salary &&
              row.settings.max_salary &&
              row.settings.min_salary > 0 &&
              row.settings.max_salary > 0
            ) {
              return `${format_currency(
                row.settings.min_salary
              )} - ${format_currency(row.settings.max_salary)}`;
            } else if (
              row.settings &&
              row.settings.min_salary &&
              row.settings.min_salary > 0
            ) {
              return `${this.$t("from")} ${format_currency(
                row.settings.min_salary
              )}`;
            } else if (
              row.settings &&
              row.settings.max_salary &&
              row.settings.max_salary > 0
            ) {
              return `${this.$t("up to")} ${format_currency(
                row.settings.max_salary
              )}`;
            } else {
              return "-";
            }
          },
        },
        {
          title: this.$t("status"),
          name: "status",
          data: (row) => {
            var status_class =
              row.status === "active" ? "is-success" : "is-danger";
            var status_text = this.$t(row.status);
            return `<span class="tag ${status_class}">${status_text}</span>`;
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.position_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete position?"),
                    v,
                    () => {
                      del("/staff/position", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.position_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
